module.exports = __webpack_public_path__ + "img/401.856b41e7.png";